import Vue from 'vue'
import Vuex from 'vuex'
import AuthBundle from './store/auth';
import MercureCheck from './store/mercure-check';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        auth: AuthBundle,
        mercure: MercureCheck
    },
    state: {},
    mutations: {},
    actions: {}
})
